import { loadState } from '../redux/helper/local_storage_helper';

/**
 * Used to send user device type to HTTPS headers
 */
const getOperatingSystem = () => {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isMobile = /iPhone|iPad|iPod|Android/i.test(userAgent)
  if (/windows phone/i.test(userAgent)) {
    return 0;
  }
  if (!isMobile) {
    return 3;
  }
  if (/Android/i.test(userAgent)) {
    return 1;
  }
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 2;
  }

  return 0;
}

/**
 * Dynamic Autherization Header
 */
export const Headers = () => ({
  headers: {
    'Content-Type': 'application/json',
    Authorization: loadState('app_user') ? `${loadState('app_user').token_type} ${loadState('app_user').access_token}` : process.env.REACT_APP_API_KEY,
    DeviceType: getOperatingSystem()
  }
});

/**
 * Initial or Default Autherization Header
 */
export const defaultHeaders = () => ({
  headers: {
    'Content-Type': 'application/json',
    Authorization: process.env.REACT_APP_API_KEY,
    DeviceType: getOperatingSystem()
  }
});

export const CheckUser = {
  url: '/api/account/check-user'
};

export const register = {
  url: '/api/account/register',
};


export const dummyuser = {
  dummyRegister: {
    url: 'api/account/register-dummy'
  },
  updateDummy: {
    url: 'api/account/update-phone'
  }
}

export const login = {
  url: '/token'
};

export const entries = {
  list: {
    url: '/api/entries/me/List'
  },
  credits: {
    url: '/api/user/credits'
  },
  gameInfo: {
    url: '/api/entries/game-info'
  },
  payConfig: {
    url: '/api/entries/pay/settings'
  }
}

export const logout = {
  url: '/api/account/logout'
}

export const Chart = {
  CurrentChartMetadata: {
    url: '/api/chart/Current'
  },
  CurrentGameMetadata: {
    url: '/api/chart/game'
  },
  LastWeekMetadata: {
    url: '/api/chart/Last-Week'
  },
  getAllSongs: {
    url: '/api/chart/Items/List'
  },
  saveChart: {
    url: '/api/chart/items/save'
  },
  startNewGame: {
    url: '/api/chart/new'
  }
}

export const PredictAward = {
  getOpenEvents: {
    url: '/api/awardshow/Open/List'
  },
  allEvents: {
    url: '/api/awardshow/All/List'
  },
  getCurrAwardsMetadata: {
    url: '/api/awardshow/Current'
  },
  CurrentGameMetadata: {
    url: '/api/awardshow/game'
  },
  saveAwardPrediction: {
    url: '/api/awardshow/Items/Save'
  }
}

export const MusicMatch = {
  getCurrentMatchupMetadata: {
    url: '/api/matchup/Current'
  },
  CurrentGameMetadata: {
    url: '/api/matchup/game'
  },
  saveMatchup: {
    url: '/api/matchup/items/save'
  },
  boost: {
    url: '/api/matchup/item/boost'
  },
  startNewGame: {
    url: '/api/matchup/new'
  }
}

export const PrizeTrivia = {
  getCurrentData: {
    url: '/api/prizetrivia/Current'
  },
  savePrizeTriviaGame: {
    url: '/api/prizetrivia/Items/Save'
  },
}

export const Bonus = {
  getCurrentBonus: {
    url: '/api/bonusgame/current'
  },
  saveBonusGame: {
    url: '/api/bonusgame/Items/Save'
  },
  getWeeklyPrize: {
    url: '/api/bonusgame/settings'
  }
}